export default {
  'Choose File': 'फाइल चुनें',
  'Please paste a URL': 'कृपया URL पेस्ट करें',
  'Loading': 'लोड हो रहा है',
  'Analyzing': 'विश्लेषण हो रहा है',
  'Try a sample': 'सैंपल आजमाएं',
  'Sorry, error occurs when analyzing the URL.': 'माफ़ करें, URL का विश्लेषण करते समय त्रुटि आ गयी थी।',
  'Upload a photo': 'तस्वीर अपलोड करें',
  "Drag and drop files to the upload box.": 'फाइलों को अपलोड बॉक्स में खींचकर छोड़ें।',
  'Please select the proper position with portrait.': 'कृपया पोर्ट्रेट के साथ उचित स्थिति चुनें।',
  'downloading': 'डाउनलोड हो रहा है',
}